import { z } from 'zod';
import { allUserRoleSchema } from '../data.types.js';
export const ProviderSupportTenantSummarySchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    subdomain: z.string(),
    isActive: z.boolean(),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
    userCount: z.number().int().nonnegative().optional(),
    containerCount: z.number().int().nonnegative().optional(),
    waferCount: z.number().int().nonnegative().optional(),
});
export const ProviderSupportTenantsResponseSchema = z.object({
    success: z.literal(true),
    data: z.object({
        tenants: z.array(ProviderSupportTenantSummarySchema),
        total: z.number().int().nonnegative(),
    }),
});
export const ProviderSupportTenantResponseSchema = z.object({
    success: z.literal(true),
    data: z.object({
        tenant: ProviderSupportTenantSummarySchema,
    }),
});
export const ProviderSupportTenantUserSchema = z.object({
    id: z.number().int().positive(),
    email: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    role: allUserRoleSchema,
    isActive: z.boolean(),
    lastLoginAt: z.coerce.date().nullable().optional(),
    createdAt: z.coerce.date().optional(),
});
export const ProviderSupportTenantUsersResponseSchema = z.object({
    success: z.literal(true),
    data: z.object({
        users: z.array(ProviderSupportTenantUserSchema),
    }),
});
export const ProviderSupportSubscriptionSummarySchema = z.object({
    tenantId: z.string().uuid(),
    subscriptionId: z.string().uuid().nullable(),
    status: z.string().nullable(),
    billingMode: z.string().nullable(),
    features: z.record(z.boolean()).optional(),
    limits: z.record(z.unknown()).optional(),
    modules: z.record(z.boolean()).optional(),
    trialEndsAt: z.coerce.date().nullable().optional(),
    currentPeriodEnd: z.coerce.date().nullable().optional(),
});
export const ProviderSupportSubscriptionResponseSchema = z.object({
    success: z.literal(true),
    data: ProviderSupportSubscriptionSummarySchema,
});
//# sourceMappingURL=provider-support.schemas.js.map